import { faArrowRight, faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Partner } from '@medprev-web-app/api-graphql-client';

import { Link } from '@/components/ui/link/link.component';
import { Icon } from '@/components/ui/icon.component';
import { formatPartnerAddress } from '@/utils/formatters/format-partner';
import { formatDistance } from '@/utils/formatters/format-distance';
import { googleMapsBaseUrl } from '@/utils/consts/google-maps.consts';
import { formatGoogleMapsAddress } from '@/utils/formatters/format-address';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

type PartnerAddressProps = {
  partner?: Partner | null;
};

export function PartnerAddress({ partner }: PartnerAddressProps) {
  const {
    neighborhood,
    city,
    state,
    addressLine1,
    addressLine2,
    zipcode,
    number,
  } = partner?.facilities?.[0] ?? {};

  const formattedAddressForLink = formatGoogleMapsAddress({
    addressLine1: addressLine1 ?? '',
    number: number ?? '',
    addressLine2: addressLine2 ?? '',
    neighborhood: neighborhood ?? '',
    city: city ?? '',
    state: state ?? '',
    zipcode: zipcode ?? '',
  });

  return (
    <section className="flex items-start gap-2">
      <div className="w-6 h-6 flex items-center justify-center">
        <Icon icon={faLocationDot} className="text-gray-500 w-6 h-6" />
      </div>
      <div className="flex flex-col">
        <p className="text-gray-700 break-words whitespace-pre-line">
          {formatPartnerAddress({
            addressLine1: addressLine1 ?? '',
            number: number ?? '',
            addressLine2: addressLine2 ?? '',
            city: city ?? '',
            state: state ?? '',
            zipcode: zipcode ?? '',
            neighborhood: neighborhood ?? '',
          })}
        </p>
        {(partner?.distance || 0) > 0 && (
          <p className="text-gray-700 font-light">
            {partner?.distance && (
              <span className="text-gray-500 font-light">{`a ${formatDistance(partner.distance)}km`}</span>
            )}
          </p>
        )}

        <span className="mt-2">
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={`${googleMapsBaseUrl}${formattedAddressForLink}`}
            className="inline-flex items-center gap-2 text-green-500 leading-6 font-semibold"
            data-analytics-event={AnalyticsEnum.CLICK_PARTNER_OPEN_MAP}
          >
            Abrir no mapa
            <Icon icon={faArrowRight} className="w-4 h-4 shrink-0" />
          </Link>
        </span>
      </div>
    </section>
  );
}
